import { render, staticRenderFns } from "./Restore.vue?vue&type=template&id=b19bff52"
import script from "./Restore.vue?vue&type=script&lang=js"
export * from "./Restore.vue?vue&type=script&lang=js"
import style0 from "./Restore.vue?vue&type=style&index=0&id=b19bff52&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports